import React, { useEffect, useState, useCallback, useContext } from 'react';
import BarChart from '../../components/charts/BarChart';
import { LineArea } from '../../components/charts/LineArea';
import { Col, DatePicker, Row, Select } from 'antd';
import { PieChart } from '../../components/charts/PieChart';
// import LineChart from '../../components/charts/LineChart';
import { Card } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Get_Analtyics } from '../../redux/Analytics/AnalyticsActions';
import PolarChart from '../../components/charts/PolarChart';
import { AlertOutlined, UserAddOutlined, UserSwitchOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import { SocketContext } from '../../context/socketContext';
import { getTickets } from '../../redux/Tickets/TicketsActions';
// import FlipClockComponent from './Counter';
// import Counter from './Counter';
const { RangePicker } = DatePicker;

const Analytics = () => {
    const dispatch = useDispatch();
    const userData = useSelector((state) => state.Auth.userData);
    const usertoken = useSelector((state) => state.Auth.token);
    const ticketsData = useSelector((state) => state.TicketsReducer.data);
    const { VisitorData, FiltredUers } =
        useContext(SocketContext);

    const visitorHasActiveAssignment = (visitor) => {
        if ((visitor?.servedBy?.length || 0) > 0) return true;
        return (visitor?.current_conversation?.agentParticipants?.length || 0) > 0;
    };

    const ActiveVisitors = VisitorData?.filter(
        (i) => i?.isIdealState === false && !visitorHasActiveAssignment(i)
    );
    const ServedVisitors = VisitorData?.filter(
        (i) => i?.isIdealState === false && visitorHasActiveAssignment(i)
    );
    const AnalyticsData = useSelector((state) => state.AnalyticsReducer.AnalyticsData);

    const totalCount =
        AnalyticsData?.TicketsCount?.result?.reduce(
            (acc, obj) => acc + (obj.count || 0),
            0
        ) ?? 0;

    const [SelectedValue, setSelectedValue] = useState(userData?.assignBrands[0]?.token || null);
    const [dateRange, setDateRange] = useState([null, null]);

    const BrandName = userData?.assignBrands?.map((i) => ({
        value: i?.token,
        label: i?.brandname,
    }));

    const fetchAnalyticsData = useCallback(() => {
        const [startDate, endDate] = dateRange || [null, null];
        const data = {
            token: SelectedValue,
            startDate: startDate ? startDate.format('YYYY-MM-DD') : null,
            endDate: endDate ? endDate.format('YYYY-MM-DD') : null,
        };
        dispatch(Get_Analtyics(data, usertoken));
    }, [SelectedValue, dateRange, dispatch, usertoken]);


    // userData (and therefore assignBrands) can load after the first render.
    // Make sure we pick the first brand as soon as it becomes available so the
    // graphs always fetch and render correct records.
    useEffect(() => {
        if (!SelectedValue && userData?.assignBrands?.length > 0) {
            setSelectedValue(userData.assignBrands[0]?.token || null);
        }
    }, [userData, SelectedValue]);

    useEffect(() => {
        if (SelectedValue) {
            fetchAnalyticsData();
        }
    }, [fetchAnalyticsData]);

    useEffect(() => {
        let data = {
            companyId: userData?.companyId,
            id: userData?._id
        }
        dispatch(getTickets(data));
    }, [])

    const handleChange = (value) => {
        setSelectedValue(value);
    };

    const onDateChange = (dates) => {
        setDateRange(dates);
    };
    const disabledDate = (current) => {
        return current && current > Date.now();
    };

    let activeUsers = FiltredUers?.filter((x) => x?.status == 22 || x?.status == 23);
    return (
        <>


            {AnalyticsData && (
                <div>
                    <Row gutter={[16, 16]}>
                        <Col xs={24} sm={12} md={12} lg={12} xl={12} xxl={6}>
                            <Card className='dashboardCard'>
                                <div className='box'>
                                    <div className='boxContent'>
                                        <h3>Active Visitors</h3>
                                        <h2>{ActiveVisitors?.length}</h2>
                                    </div>
                                    <div className='boxIcon'>
                                        <UserAddOutlined style={{ fontSize: '28px' }} />
                                    </div>
                                </div>
                            </Card>
                        </Col>
                        <Col xs={24} sm={12} md={12} lg={12} xl={12} xxl={6}>
                            <Card className='dashboardCard served'>
                                <div className='box'>
                                    <div className='boxContent'>
                                        <h3>Served</h3>
                                        <h2>{ServedVisitors?.length}</h2>
                                    </div>
                                    <div className='boxIcon'>
                                        <UserSwitchOutlined style={{ fontSize: '28px' }} />
                                    </div>
                                </div>
                            </Card>
                        </Col>
                        <Col xs={24} sm={12} md={12} lg={12} xl={12} xxl={6}>
                            <Card className='dashboardCard ticket'>
                                <div className='box'>
                                    <div className='boxContent'>
                                        <h3>Ticket Counts</h3>

                                        <h2>{totalCount} </h2>
                                    </div>
                                    <div className='boxIcon'>
                                        <AlertOutlined style={{ fontSize: '28px' }} />
                                    </div>
                                </div>
                            </Card>
                        </Col>
                        <Col xs={24} sm={12} md={12} lg={12} xl={12} xxl={6}>
                            <Card className='dashboardCard agent'>
                                <div className='box'>
                                    <div className='boxContent'>
                                        <h3>Agent Online</h3>
                                        <h2>{activeUsers?.length}</h2>
                                    </div>
                                    <div className='boxIcon'>
                                        <UsergroupAddOutlined style={{ fontSize: '28px' }} />
                                    </div>
                                </div>
                            </Card>
                        </Col>
                    </Row>
                    <Row gutter={[16, 16]}>
                        <div className="historytopbtn analytics-topbar">
                            <div className="analytics-filters">
                                <Select
                                    value={SelectedValue}
                                    className="analytics-brand-select"
                                    onChange={handleChange}
                                    options={BrandName}
                                />
                                <RangePicker
                                    className="analytics-range-picker"
                                    format="DD-MM-YYYY"
                                    onChange={onDateChange}
                                    disabledDate={disabledDate}
                                />
                            </div>
                        </div>
                        <Col xs={24}>
                            <Card
                                title="Total Visits"
                                headStyle={{ textAlign: 'center', fontSize: '17px', fontWeight: 600, letterSpacing: '1px' }}
                                style={{ width: '100%', margin: '10px 0px' }}
                            >
                                <BarChart AnalyticsData={AnalyticsData} />
                            </Card>
                        </Col>
                    </Row>
                    <Row gutter={[16, 16]}>
                        <Col xs={24}>
                            <Card
                                title="Total WebPages Visits"
                                headStyle={{ textAlign: 'center', fontSize: '17px', fontWeight: 600, letterSpacing: '1px' }}
                                style={{ width: '100%', height: '98%', margin: '5px 0px' }}
                            >
                                <LineArea AnalyticsData={AnalyticsData} style={{ width: '100%' }} className="line-area-chart" />
                            </Card>
                        </Col>
                    </Row>
                    <Row className="analytics-charts-row">
                        <Col
                            xs={24}
                            sm={24}
                            className="analytics-chart-col"
                        >
                            <Card
                                className="analytics-chart-card"
                                title="Total Referrers"
                                headStyle={{ textAlign: 'center', fontSize: '17px', fontWeight: 600, letterSpacing: '1px' }}
                                style={{ width: '100%', margin: '5px 0px' }}
                            >
                                <PolarChart AnalyticsData={AnalyticsData} />
                            </Card>
                        </Col>
                        {/* <Col xs={24} sm={24} md={12} lg={12} xl={12} className="analytics-chart-col">
                            <Card
                                className="analytics-chart-card"
                                title="Ticket Status"
                                headStyle={{ textAlign: 'center', fontSize: '17px', fontWeight: 600, letterSpacing: '1px' }}
                                style={{ width: '100%', margin: '5px 0px' }}
                            >
                                <PieChart ticketsData={ticketsData} />
                            </Card>
                        </Col> */}
                    </Row>
                </div >
            )}
        </>
    );
};

export default Analytics;
